import React, { useState, useContext } from "react";
import axios from "axios";
import AuthContext from "../../../../context/userAuth.context";
import MyContext from "../../../../context/MyContext";
import ProjectContext from "../../../../context/ProjectContext";
import TickerContext from "../../../../context/ticker";
import swal from "sweetalert";
import Lottie from "react-lottie";
import loader from "../../../../assets/Loader/AssetLoader.json";
//file updated
const Scenes = ({ lmc, ScenesFolder, setScenesFolder }) => {
  const { authenticationData, Role } = useContext(AuthContext);
  const [ShowItems, setShowItems] = useState(false);
  const { Goto, setGoto } = useContext(TickerContext);
  const { slides, setslides, setChangeCount } = useContext(ProjectContext);
  const { LayersData, setUndoLayer, setRedoLayer, setLayersData, EditorZoom, 
    Call_CurrentProject, 
    setCall_CurrentProject } =
    useContext(MyContext);
  const [Loader, setLoader] = useState(false);

  const showUploadedScenes = () => {
    //if (lmc.data.length == 0) {
    setLoader(true);
    let authData = JSON.parse(
      localStorage.getItem("animation_studio_2.0_access_token")
    );
    axios
      .get(authenticationData.ApiBaseURL + "/api/Slides/GetUserSlide", {
        headers: {
          "Content-Type": `multipart/form-data`,
          "Access-Control-Allow-Origin": "*",
          Authorization: "Bearer " + authData.access_token,
        },
      })
      .then((response) => {
        if (response.data.status) {
          let arr = Array.from(ScenesFolder);
          for (let i = 0; i < arr.length; i++) {
            if (arr[i].id == lmc.id) {
              arr[i].data = response.data.slides;
            }
          }
          setScenesFolder(arr);
          setLoader(false);
        }
      })
      .catch((err) => {
        setLoader(false);
      });
    setShowItems(!ShowItems);
    //console.log(lmc.data.length);
  };

  const getSlidesByCategory = () => {
    setLoader(true);
    let authData = JSON.parse(
      localStorage.getItem("animation_studio_2.0_access_token")
    );
    axios
      .get(
        authenticationData.ApiBaseURL +
          `/api/Slides/GetSlidesByCategory?id=${lmc.id}&lite=true`,
        {
          headers: {
            "Content-Type": `multipart/form-data`,
            "Access-Control-Allow-Origin": "*",
            Authorization: "Bearer " + authData.access_token,
          },
        }
      )
      .then((response) => {
        if (response.data.status) {
          let arr = Array.from(ScenesFolder);
          for (let i = 0; i < arr.length; i++) {
            if (arr[i].id == lmc.id) {
              arr[i].data = response.data.slides;
            }
          }
          setScenesFolder(arr);
          setLoader(false);
        }
      })
      .catch((err) => {
        setLoader(false);
      });
    setShowItems(!ShowItems);
  };

  const convertLayer = (layer, width, height, Currwidth, Currheight) => {
    const array = Array.from(layer);
    if (height && width) {
      let heightRatio = height / Currheight;
      let widthRatio = width / Currwidth;

      for (let i = 0; i < array.length; i++) {
        if (array[i].type === "Character") {
          array[i].Added = true;
        }
        //doing this to create a new ID for objects in new slide (to avoid same dragging issue of same object id)
        array[i].AnimationId = makeid(7);

        array[i].x = array[i].x / widthRatio;
        // // THIS MULTIPLICATION IS BECAUSE POSITION AND SIZE ARE ALREADY ZOOM ADJUSTED SO WE REVERT BACK
        // // array[i].x = (array[i].x / EditorZoom) * 100;

        array[i].width = array[i].width / widthRatio;
        // array[i].width = (array[i].width * EditorZoom) / 100;

        array[i].y = array[i].y / heightRatio;
        // array[i].y = (array[i].y * EditorZoom) / 100;

        array[i].height = array[i].height / heightRatio;
        // array[i].height = (array[i].height * EditorZoom) / 100;

        array[i].originalX = array[i].originalX / widthRatio;
        // array[i].originalX = array[i].originalX;

        array[i].originalY = array[i].originalY / heightRatio;
        // array[i].originalY = array[i].originalY;

        array[i].originalWidth = array[i].originalWidth / widthRatio;
        // array[i].originalWidth = array[i].originalWidth;

        array[i].originalHeight = array[i].originalHeight / heightRatio;
        // array[i].originalHeight = array[i].originalHeight;

        if (array[i].fontSize) {
          array[i].fontSize = parseInt(array[i].fontSize / heightRatio);
        }
        if (array[i].originalFontSize) {
          array[i].originalFontSize = parseInt(
            array[i].originalFontSize / heightRatio
          );
        }
      }
    } else {
      for (let i = 0; i < array.length; i++) {
        if (array[i].type === "Character") {
          array[i].Added = true;
        }
        // //doing this to create a new ID for objects in new slide (to avoid same dragging issue of same object id)
        array[i].AnimationId = makeid(7);
      }
    }

    return array;
  };

  function makeid(length) {
    var result = "";
    var characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }
  // The scene list comes without the scenes' layers (much faster); a scene's layers are fetched
  // when it is loaded, and kept on the list item for the next time.
  const [SceneLoading, setSceneLoading] = useState(false);
  const NewSlides = (data) => {
    if (data.layerData) return applyScene(data);
    if (SceneLoading) return;
    let authData = JSON.parse(localStorage.getItem("animation_studio_2.0_access_token"));
    setSceneLoading(true);
    axios
      .get(
        authenticationData.ApiBaseURL +
          `/api/Slides/GetSlideById?id=${data.id}&user=${lmc.id == 0 ? "true" : "false"}`,
        { headers: { Authorization: "Bearer " + authData.access_token } }
      )
      .then((response) => {
        setSceneLoading(false);
        if (!response.data.status || !response.data.slide) {
          swal("Failed", "This scene could not be loaded. Please try again.", "error");
          return;
        }
        Object.assign(data, response.data.slide);
        applyScene(data);
      })
      .catch(() => {
        setSceneLoading(false);
        swal("Failed", "This scene could not be loaded. Please try again.", "error");
      });
  };

  const applyScene = (data) => {
  
    let element = document.getElementsByClassName("EditorTrackInner")[0];
    let Currwidth = parseInt(element.style.width.split("px")[0]);
    let Currheight = parseInt(element.style.height.split("px")[0]);

    let projData = JSON.parse(data.layerData);

    for (let i = 0; i < projData.length; i++) {
      if (projData[i].type == "text" && !projData[i].googleFontSetting) {
        projData[i].googleFontSetting = {
          fontName: "Roboto",
          fontFamily: "'Roboto', sans-serif",
          googleFontUrl:
            "https://fonts.googleapis.com/css2?family=Roboto:wght@100&display=swap",
        };
      }
    }

    data.layerData = JSON.stringify(projData);

    let layer = convertLayer(
      JSON.parse(data.layerData),
      data.canvasWidth,
      data.canvasHeight,
      Currwidth,
      Currheight
    );

    //console.log("WHAAATTT", layer);

    if (Goto.menu == "Scene") {
      // A key no slide has yet (slides.length + 1 can be taken after slides were deleted).
      const freeKey = slides.reduce((max, s) => (typeof s.key === "number" && s.key > max ? s.key : max), -1) + 1;
      let obj = {
        key: freeKey,
        LayerData: layer,
        IsActive: true,
        SlideBackground: JSON.parse(data.slideBackground),
        TotalLength: data.totalLength,
        SlideImage: data.slideImage,
        SmallTime: data.smallTime,
        canvasWidth: Currwidth,
        canvasHeight: Currheight,
      };

      const array = Array.from(slides);
      let index;
      for (var i = 0; i < array.length; i++) {
        if (array[i].IsActive === true) {
          array[i].IsActive = false;
          array[i].LayerData = LayersData;
          index = i;
        }
      }
      let ind = index + 1;
      array.splice(ind, 0, obj);
      setLayersData([]); // the canvas then loads the new slide (as when adding a slide elsewhere)
      setslides(array);
      setUndoLayer([]);
      setRedoLayer([]);
      setChangeCount(6);
      setGoto({
        menu: null,
        innerMenu: null,
        key: null,
      });
    } else {
      // Scenes are not filtered by video shape. A 16:9 scene in a 9:16 project (or the reverse)
      // is stretched to fit, so say so before loading it.
      const sceneRatio = data.canvasWidth && data.canvasHeight ? data.canvasWidth / data.canvasHeight : null;
      const projectRatio = Currwidth && Currheight ? Currwidth / Currheight : null;
      const otherShape = sceneRatio && projectRatio && Math.abs(sceneRatio / projectRatio - 1) > 0.15;
      swal({
        title: "Really want to load this scene..?",
        text: otherShape
          ? "This scene was made for a different video shape, so its pictures and text will be stretched to fit."
          : "",
        buttons: true,
        dangerMode: false,
      }).then((value) => {
        if (value) {
          let length = slides.length;
          let obj = {
            key: length,
            LayerData: layer,
            IsActive: true,
            SlideBackground: JSON.parse(data.slideBackground),
            TotalLength: data.totalLength,
            SlideImage: data.slideImage,
            SmallTime: data.smallTime,
            canvasWidth: Currwidth,
            canvasHeight: Currheight,
          };
          const array = Array.from(slides);

          //

          for (var i = 0; i < array.length; i++) {
            if (array[i].IsActive === true) {
              array[i].IsActive = false;
              array[i].LayerData = LayersData;
            }
            array[i].key = i;
          }
          //Did this to clear canvas before adding another slide data.
          setLayersData([]);
          setslides(array.concat(obj));
          setUndoLayer([]);
          setRedoLayer([]);
          setChangeCount(6);
          setCall_CurrentProject(!Call_CurrentProject)
        }
      });
    }
  };

  const deleteSlide = (obj, index) => {
    var id = obj.id;
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this scene!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((value) => {
      if (value) {
        let authData = JSON.parse(
          localStorage.getItem("animation_studio_2.0_access_token")
        );
        axios
          .get(
            authenticationData.ApiBaseURL +
              "/api/Slides/DeleteUserSlide?id=" +
              id +
              "&imgPath=" +
              obj.slideImage,
            {
              headers: {
                "Content-Type": `multipart/form-data`,
                "Access-Control-Allow-Origin": "*",
                Authorization: "Bearer " + authData.access_token,
              },
            }
          )
          .then((response) => {
            if (response.data.status) {
              let arr = Array.from(ScenesFolder);
              for (let i = 0; i < arr.length; i++) {
                if (arr[i].id == lmc.id) {
                  arr[i].data = arr[i].data.filter((item) => item.id !== id);
                }
              }

              setScenesFolder(arr);

              swal("Your slide has been deleted!", {
                icon: "success",
              });
            } else {
              swal("Some error occured!", {
                icon: "error",
              });
            }
          })
          .catch((error) => {
            //console.log(error);
            swal("Some error occured!", {
              icon: "error",
            });
          });
      }
    });
  };

  return (
    <>
      <div className="CharacterShow2">
        <div className="character_container" style={{ background: "#ffffff" }}>
          <div className="character_container_insider">
            <div className="Chr_cont_folder">
              <div className="chr_cont_name">{lmc.categoryName}</div>

              <div className="Chr_folder_insider" onClick={getSlidesByCategory}>
                <img
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                  src={authenticationData.ApiBaseURL + "/" + lmc.defaultImgPath}
                  alt=""
                />
              </div>

              {/* <div className="Chr_folder_insider"  >
                            <span
                                className="maskclas"
                                style={{ background: "#ffffff" }}
                            ></span>
                            <img
                                style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                src={authenticationData.ApiBaseURL + "/" + lmc.defaultImgPath}
                                alt=""
                            />
                        </div> */}

              {lmc.id == 0 && (
                <div className="folderExpand" onClick={showUploadedScenes}>
                  {ShowItems && (
                    <span
                      style={{
                        top: "7px",
                        fontSize: "12px",
                        fontWeight: "600",
                      }}
                      className="material-icons folderExpand_icon"
                    >
                      close
                    </span>
                  )}
                  {!ShowItems && (
                    <span
                      style={{
                        top: "9px",
                        right: "12px",
                        fontSize: "16px",
                        fontWeight: "600",
                      }}
                      className="material-icons folderExpand_icon"
                    >
                      expand_more
                    </span>
                  )}
                </div>
              )}

              {lmc.id != 0 && (
                <div className="folderExpand" onClick={getSlidesByCategory}>
                  {ShowItems && (
                    <span
                      style={{
                        top: "7px",
                        fontSize: "12px",
                        fontWeight: "600",
                      }}
                      className="material-icons folderExpand_icon"
                    >
                      close
                    </span>
                  )}
                  {!ShowItems && (
                    <span
                      style={{
                        top: "9px",
                        right: "12px",
                        fontSize: "16px",
                        fontWeight: "600",
                      }}
                      className="material-icons folderExpand_icon"
                    >
                      expand_more
                    </span>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {ShowItems && (
        <div className="Character_folder_items">
          <div className="chr_cont_name">
            Showing results for: {lmc.categoryName}
          </div>
          <div className="seperator" style={{ width: "100%", height: "auto" }}>
            {Loader == true && (
              <Lottie
                options={{ loop: true, autoplay: true, animationData: loader }}
                height={120}
                width={120}
                isStopped={false}
                isPaused={false}
              />
            )}
            <div className="Char_assetsList">
              {!Loader && lmc.data.length === 0 && (
                <div className="Character_folder_items">
                  <p className="displayMsg">No item available currently.</p>
                </div>
              )}
              {!Loader &&
                lmc.data.map((obj, index) => (
                  <div
                    key={index}
                    className="Asset_items slide-loader-wrapper"
                    style={{ flexBasis: "46.8%", position: "relative" }}
                  >
                    <img
                      src={authenticationData.ApiBaseURL + "/" + obj.slideImage}
                      style={{ width: "100%", borderRadius: "0px" }}
                    />
                    <div
                      className="slideLoaderMenu"
                      style={{
                        background: "rgba(0, 0, 0, 0.5)",
                        borderRadius: "0px",
                      }}
                    >
                      <div className="slideButtonWrapper">
                        <button
                          className="slideButtons"
                          title="Load Slide"
                          onClick={() => {
                            NewSlides(obj, index);
                          }}
                        >
                          <span
                            className="material-icons"
                            style={{ marginTop: "3px" }}
                          >
                            file_upload
                          </span>
                        </button>
                        {Role != "user" && lmc.id != 0 && (
                          <button
                            className="slideButtons"
                            title="Delete Slide"
                            onClick={() => {
                              deleteSlide(obj, index);
                            }}
                          >
                            <span
                              className="material-icons"
                              style={{ marginTop: "3px" }}
                            >
                              delete
                            </span>
                          </button>
                        )}
                        {lmc.id == 0 && (
                          <button
                            className="slideButtons"
                            title="Delete Slide"
                            onClick={() => {
                              deleteSlide(obj, index);
                            }}
                          >
                            <span
                              className="material-icons"
                              style={{ marginTop: "3px" }}
                            >
                              delete
                            </span>
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Scenes;
